// pipe (Sites admin): sidebar entry for the Sites (facility admin) screen. Cloned from
// customers-button.tsx (verbatim shape) PLUS an admin-tier gate: it renders ONLY for an admin-tier
// actor (a super-admin, or a facility's pipe_admin) — gated on the SERVER's `/me/provisioning` isAdmin
// flag via the shared `useErpProvisioning` SSOT (the SAME source the Sites screen reads; never a
// client-side role re-derivation). A non-admin (operational staff / no pipe_* role) sees NOTHING, and
// fail-closed: while provisioning is unresolved or on error it stays hidden, so the entry never flashes
// for a non-admin. The Core API enforces the gate on every Sites request regardless of this affordance.
import { useI18n } from '@affine/i18n';
import { LocalWorkspaceIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { useErpProvisioning } from '../../modules/erp';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const SitesButton = () => {
  const t = useI18n();
  const provisioning = useErpProvisioning();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any `/sites` route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/sites');

  // The gate: hidden unless the server says the actor is admin-tier (fail-closed on null).
  if (!provisioning?.isAdmin) {
    return null;
  }

  return (
    <MenuLinkItem icon={<LocalWorkspaceIcon />} active={active} to={'/sites'}>
      <span data-testid="pipe-sites-nav">
        {t['com.affine.pipe.sites.nav']()}
      </span>
    </MenuLinkItem>
  );
};
